
import { Component, Prop, Vue } from 'vue-property-decorator';

// SVG
import AngleRightSVG from '@/assets/angle_right.svg';

// Components
import VButtonIcon from '@/components/VButton/VButtonIcon.vue';

// Interfaces
import { Location } from 'vue-router';

interface ILocation extends Location {
    label?: string;
}

// Utils
import { isInterface } from '@/utils/Helper';
import PageService from '@/utils/PageService';

@Component({
    components: {
        AngleRightSVG,
        VButtonIcon,
    },
})
export default class VBreadcrumbs extends Vue {
    @Prop({ type: Array, required: true })
    public routes!: ILocation[] | string[];

    @Prop({ type: [Object, String], default: null })
    public currentRoute!: ILocation | string;

    // accepts only names as string in routes array
    @Prop({ type: Boolean, default: false })
    public reduced!: boolean;

    public getRoute(route: ILocation | string): Location {
        return this.reduced ? { name: route as string } : (route as Location);
    }

    public getTitle(route: ILocation | string) {
        if (typeof route === 'object' && isInterface<ILocation>(route, ['label'])) return route.label;
        return PageService.getPageTitle(this.getRoute(route));
    }
}
